import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import Background from './Background'; // Integrating global background
import './Doctors.css';
// Footer component
import Footer from './Footer';

// Flattened list as per reference style (Number 01 - 11)
const doctors = [
    { id: 1, name: 'Dr. Samip Gupta', role: 'Founder & Physical Therapist', img: '/samip_1.png', bio: 'He holds a Bachelor\'s Degree in Physiotherapy from Rajiv Gandhi University of Health Sciences, Karnataka (Reg: L/27342). Diagnosing expert with 17+ years of invaluable experience, he served as Head Physiotherapist at Cumballa Hill Hospital. Renowned for specialized skills in chiropractic spine adjustments, he has extensive expertise in treating orthopedic and sports injuries.' },
    { id: 2, name: 'Dr. Komal Panchal Gupta', role: 'Co-Founder & Director', img: '/komal.png', bio: 'Graduating from Sancheti Institute of Orthopaedic and Rehabilitation in 2014, she gained experience in ICU and outpatient care at Bombay Hospital (2014-2021). Registration: PT 008677. She provided treatment for various injuries and postoperative cases, enhancing her clinical exercises and physiological training expertise for patient rehabilitation.' },
    // { id: 3, name: 'Dr. Renuka', role: 'Senior Consultant', img: '/bhoomi.png', bio: 'Provides therapeutic yoga and antenatal postnatal care, focusing on safe rehabilitation, pain management, mobility, posture correction, breathing techniques, stress reduction, and holistic maternal health outcomes' },
    { id: 3, name: 'Dr. Sheetal Rane', role: 'Senior Consultant', img: '/sheetal.png', bio: 'With 20+ years of experience, she specializes in rehabilitation, acute/chronic injuries, and post-operative care. She holds a Physiotherapy degree from LTMMC (Sion Hospital) and PGDM in Healthcare Management. A Certified Manual Therapy Practitioner, she led the physiotherapy department at Bhatia Hospital for 7 years. IAP Registration: L-15325.' },
    { id: 4, name: 'Dr. Nilav Jadhav', role: 'Senior Consultant', img: '/nilav.png', bio: 'Consultant Physiotherapist and Head of the Home Visit Department at GOPT. He holds a BPTh from KJ Somaiya College of Physiotherapy (IAP: 63429, OTPT: 2024/10/PT/013261). With expertise in musculoskeletal, neurological, geriatric, and post-operative rehabilitation, he delivers evidence-based, patient-centric care with meticulous assessment and personalized treatment planning.' },
    { id: 5, name: 'Dr. Shivam Patel', role: 'Senior Consultant', img: '/shivam.png', bio: 'Senior Physiotherapist with a Master\'s degree from the UK and over one year of clinical experience. Specializes in accurate assessment, diagnosis, and personalized treatment using advanced technologies including Tecar Therapy, Shockwave Therapy, and Functional Magnetic Stimulation (FMS). Known for strong clinical decision-making and excellent patient handling skills.' },
    { id: 6, name: 'Dr. Bhoomi Gosar', role: 'Senior Consultant', img: '/bhoomi.png', bio: 'A dedicated physiotherapist passionate about helping individuals achieve optimal health and wellness. She completed her Bachelor\'s in Physiotherapy from Sardar Patel University, Anand, Gujarat. Certified in Dry Needling and Manual Therapy, she aims to improve every individual\'s quality of life.' },
    { id: 7, name: 'Dr. Merwyn Dantas', role: 'Consultant', img: '/merwyn.png', bio: 'Compassionate and skilled Physiotherapist with strong clinical knowledge and hands-on experience in musculoskeletal and orthopedic rehabilitation. Known for accurate assessment, individualized treatment planning, and a patient-centric approach focused on pain relief, functional recovery, and long-term outcomes.' },
    { id: 8, name: 'Dr. Nahid Shaikh', role: 'Consultant', img: '/nahid.png', bio: 'A qualified Physiotherapist with a Bachelor\'s degree from St. Andrews College of Physiotherapy, Pune. Completed clinical internship at Ruby Hall Clinic, Vishwaraj Hospital, Sahyadri Hospital, and other reputed institutions. Expertise in womens health and geriatric care with experience in musculoskeletal and neurological conditions including ICU exposure, she provides evidence-based, patient-centered care focused on recovery and long-term wellbeing.' },
    { id: 9, name: 'Dr. Rabia Artianawala', role: 'Consultant', img: '/rabia.png', bio: 'A dedicated Physiotherapist focused on improving health, mobility, and overall well-being. She completed her Bachelor\'s in Physiotherapy from Lokmanya Tilak College of Physiotherapy, Mumbai. With certifications in Dry Needling and Kinesiotaping, she delivers effective, patient-centered treatment to improve quality of life.' },

    { id: 10, name: 'Dr. Gresha', role: 'Consultant', img: '/gresha.png', bio: 'She completed her graduation from Sikkim Manipal University. A certified Manual Therapist with 15+ years of experience, she started her practice at Bombay Hospital, gaining experience in rehabilitative treatment for post-surgical cases and ICU training. She has also worked at Parsee General, Ram Krishna Mission, and Ruxmani Hospital. MIAP: 36532, OTPT: 004703.' },
];

const getDoctorTier = (role) => {
    const r = role.toLowerCase();
    if (r.includes('founder')) return 'founder';
    if (r.includes('senior')) return 'senior';
    return 'junior';
};

const getDesignation = (role) => {
    const r = role.toLowerCase();
    if (r.includes('co-founder')) return 'CO-FOUNDER';
    if (r.includes('founder')) return 'FOUNDER';
    if (r.includes('senior')) return 'SENIOR CONSULTANT';
    return 'CONSULTANT';
};

const Doctors = () => {
    const [activeId, setActiveId] = useState(1);
    const activeDoctor = doctors.find(d => d.id === activeId);

    // Auto-scroll the nav list to keep active number in view
    const navRef = useRef(null);

    useEffect(() => {
        if (navRef.current) {
            // basic scroll into view logic if needed
        }
    }, [activeId]);

    const handlePrev = () => {
        setActiveId(prev => (prev === 1 ? doctors.length : prev - 1));
    };

    const handleNext = () => {
        setActiveId(prev => (prev === doctors.length ? 1 : prev + 1));
    };

    // Keyboard arrow navigation
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                e.preventDefault();
                handleNext();
            } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                e.preventDefault();
                handlePrev();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    });

    return (
        <div className="doctors-page-container">
            <Background phase="home" />

            {/* Decorative backdrop shape */}
            <div className="backdrop-curve"></div>

            <div className="content-wrapper">

                {/* LEFT: Info */}
                <div className={`info-col tier-${getDoctorTier(activeDoctor.role)}`}>
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={activeDoctor.id}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.3, ease: "easeOut" }}
                            className={`tier-${getDoctorTier(activeDoctor.role)}`}
                        >
                            <span className="doctor-role-label">{activeDoctor.role}</span>
                            <h1 className="doctor-name-display">{activeDoctor.name}</h1>
                            {activeDoctor.tag && <span className="doctor-tag">{activeDoctor.tag}</span>}
                            <p className="doctor-bio-display">{activeDoctor.bio}</p>
                        </motion.div>
                    </AnimatePresence>

                    <div className="doctor-nav-buttons">
                        <button className="nav-arrow-btn prev" onClick={handlePrev} aria-label="Previous Doctor">
                            <ArrowLeft size={42} strokeWidth={1.5} />
                        </button>
                        <button className="nav-arrow-btn next" onClick={handleNext} aria-label="Next Doctor">
                            <ArrowRight size={42} strokeWidth={1.5} />
                        </button>
                    </div>
                </div>

                {/* CENTER: Image */}
                <div className="image-col">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={activeDoctor.id} // Keep the mask transition which is nice
                            className={`image-mask tier-${getDoctorTier(activeDoctor.role)}`}
                            initial={{ opacity: 0, x: 50 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -50 }}
                            transition={{ duration: 0.4, ease: "anticipate" }}
                        >
                            {/* Pre-render ALL images to keep them decoded in DOM */}
                            {doctors.map((doc) => (
                                <img
                                    key={doc.id}
                                    src={doc.img}
                                    alt={doc.name}
                                    className={`doctor-hero-img ${doc.id === activeId ? 'active' : ''}`}
                                    style={{
                                        opacity: doc.id === activeId ? 1 : 0,
                                        zIndex: doc.id === activeId ? 2 : 1,
                                        display: 'block' // Always display, just hide with opacity
                                    }}
                                />
                            ))}
                        </motion.div>
                    </AnimatePresence>
                </div>

                {/* RIGHT: Navigation */}
                <div className="nav-col">
                    <div className="nav-list" ref={navRef}>
                        {doctors.map((doc, index) => {
                            const currentTier = getDoctorTier(doc.role);
                            const prevTier = index > 0 ? getDoctorTier(doctors[index - 1].role) : null;
                            const showDivider = prevTier && prevTier !== currentTier;

                            return (
                                <React.Fragment key={doc.id}>
                                    {showDivider && <div className="tier-divider"></div>}
                                    <div
                                        className={`nav-item ${currentTier} ${doc.id === activeId ? 'active' : ''}`}
                                        onClick={() => setActiveId(doc.id)}
                                    >
                                        {doc.id === activeId && (
                                            <motion.div
                                                layoutId="active-line"
                                                className="active-line"
                                            />
                                        )}
                                        {doc.id.toString().padStart(2, '0')}
                                    </div>
                                </React.Fragment>
                            );
                        })}
                    </div>
                    {/* Vertical Designation on the right */}
                    <div className="vertical-designation-container">
                        <span className="vertical-designation-text">
                            {getDesignation(activeDoctor.role)}
                        </span>
                    </div>
                </div>

            </div>

            {/* =========================================
          COMPACT FOOTER (Synced with Home.js)
         ========================================= */}
            <Footer />
        </div>
    );
};

export default Doctors;